import React, { useEffect, useState } from "react";
import ai_img from "../../assets/img/img-logo.svg";
import { Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import OTPInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { clearDataOtp, otpVerification } from "../../redux/OtpSlice";
import { useLocation, useNavigate } from "react-router-dom";

const Otp = ({ routes }) => {
  const [otp, setOtp] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  const { id, fromScreen } = location.state;


  const dispatch = useDispatch();

  const otpResponse = useSelector((state) => state.otpVerificationReducer.data);

  const onSubmitClick = () => {
    const payload = {
      type: 1,
      _id: id,
      otp: otp,
    };

    dispatch(otpVerification(payload));
  };

  useEffect(() => {
    if (otpResponse != null && otpResponse.status === 1) {
      localStorage.setItem("token", otpResponse.token);
      dispatch(clearDataOtp());
      if (fromScreen == 1) {
        navigate("/Project");
      } else {
        // navigate("/CreateProfile");
        navigate("/Project");
      }
    } else {
      dispatch(clearDataOtp());
      if (otpResponse != null) {
        alert(otpResponse.message);
      }
    }
  }, [otpResponse]);

  return (
    <>
      <div className="inner">
        <div className="sec_bg">
          <div className="logotype">
            <img src={ai_img} alt="ai_img" />
            <p>
              Power up your workflow with Task AI.
              <br />
              <br />
              Upload files, ask questions, and get instant answers. <span style={{ fontStyle: 'italic' }}>No more guesswork. <br /> No more wasted time.</span>
              <br />
              <br />
              <span style={{ fontWeight: 700 }}>Let's get to work.</span>
            </p>
          </div>

        </div>
        <div className="signup_bg">
          <div className="text_btn" onClick={() => navigate(-1)} style={{
            'cursor': 'pointer', 'textAlign': 'left', marginLeft: '34px',
            justifyContent: 'flex-start '
          }}>Back</div>
          <div className="signup_form">
            <Form>
              <h3>Enter OTP</h3>
              <p className="numnber_otp">
                Enter 6-digit code we just send to you
                {/* <span>
                  <b>+91 9855 6584 991</b>
                </span> */}
              </p>
              <Form.Group className="mb-3 input_otp" controlId="formBasicEmail">
                <OTPInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  renderSeparator={<span className="space"></span>}
                  renderInput={(props) => <input {...props} />}
                />
              </Form.Group>
              <div className="next_btn">
                <Button onClick={() => onSubmitClick()}>Submit</Button>
              </div>
              <div class="separator">
                <span>or</span>
              </div>
              <p className="numnber_otp resend-code">Resend Code</p>
            </Form>
          </div>

          <p>
            Protected by reCAPTCHA and subject to the Rhombus <br />
            <b>Privacy Policy</b> and <b>Terms of Service.</b>
          </p>
        </div>
      </div>
    </>
  );
};

export default Otp;
